import React from "react";
import "./HomePage.css";
function HomePage() {
  const playVideo = () => {
    const videoElement = document.getElementById("myvid");
    if (videoElement) {
      videoElement.play();
    }
  };
  return (
    <>
      <div className="home-page">
        <section className="banner">
          <div className="banner-content">
            <h1 className="heading ">
              Dive into Astrality, a fusion of limitless potential and tangible
              reality.
            </h1>
            <p className="para">
              Pioneering the metaverse with a blend of commerce, creativity, and
              community, enriched by AI-enhanced interactions. Experience our
              unique digital marketplace and vibrant social platform today.
              Embark on the future with Astrality.
            </p>
            <div className="d-flex align-items-center">
              <button className="btn-1 ">Join Now</button>
              <button className="btn-2">Learn More</button>
            </div>
          </div>
          {/* Banner background */}
          <div className="sign-video">
            <video autoPlay loop muted playsInline id="myvid">
              <source
                src="../../../assets/videos/Banner.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div className="banner-layer"></div>
        </section>

        {/* What Astrality */}

        <div className="what-astrality ">
          <div className="what-astrality-content">
            <div className="left">
              <h1 className="heading">What is Astrality?</h1>
              <p className="para">
                Step into Astrality, the frontier of the metaverse where
                infinite astral expanses meet tangible reality. Our platform
                reimagines digital commerce, fusing real-world brands and NFTs
                into an interactive marketplace. At Astrality, own and
                personalize virtual land, immerse in vibrant social encounters,
                and experience the future of the digital universe, enhanced by
                AI. Embrace Astrality's limitless potential and experience where
                reality converges with the metaverse.
              </p>
              <button className="btn-1 ">Explore Now</button>
            </div>
            <div className="what-astrality-image">
              <img
                src="\assets\images\HomePage-images\astrality-image.png"
                alt="astrality-image"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
        {/* Digital Land */}
        <div className="digital-land digital-land-bg ">
          <div className="digital-land-content  ">
            <div className="digital-land-img">
              {/* <img
                src="\assets\images\HomePage-images\DigitalLand-image.gif"
                alt="digital-land"
                className="img-fluid new-digi-img"
              /> */}
              <video
                autoPlay
                loop
                muted
                playsInline
                className="img-fluid new-digi-img"
              >
                <source
                  src="\assets\videos\Homepage-videos\DigitalLand-image.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="digital-land-hpb ">
              <h1 className="heading">Digital Land</h1>
              <p className="para ">
                Experience ultimate ownership in Astrality, your gateway to a
                metaverse where you can buy, sell, rent, or trade digital land.
                Customize your unique space using our easy-to-use Astrality SDK,
                no coding skills required. Become a part of Astrality, the next
                generation metaverse, where you can craft your digital domain.
              </p>
              <button className="btn-1 mt-3">Buy Now</button>
            </div>
          </div>
        </div>
        {/* Market Place */}
        <div className="market-place new-market-place">
          <div className="market-place-content">
            <div className="digital-land-hpb">
              <h1 className="heading">Marketplace</h1>
              <p className="para">
                Discover the Marketplace in Astrality, a fusion of real and
                virtual commerce. Shop for NFTs from real-world brands and
                experience a new era of shopping. Astrality sets the stage for
                Web3 commerce, bridging brands and the metaverse. Embark on a
                new commerce journey with us.
              </p>
              <button className="btn-1 mt-3">Shop Now</button>
            </div>
            <div className="digital-land-img-size new-market-img">
              {/* <img
                src="\assets\images\HomePage-images\MarketPlace.gif"
                alt="digital-land"
                className="img-fluid new-img"
              /> */}
              <video
                autoPlay
                loop
                muted
                playsInline
                className="img-fluid new-img"
              >
                <source
                  src="\assets\videos\Homepage-videos\MarketPlace.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
        {/* AI Powered Metaverse  */}
        <div className="AI-background digital-land-bg ">
          <div className="digital-land new-AI">
            <div className="digital-land-content new-AI-content ">
              <div className="digital-land-img">
                {/* <img
                  src="\assets\images\HomePage-images\AI-Powered.gif"
                  alt="digital-land"
                  className="img-fluid new-AI-img"
                /> */}
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="img-fluid new-AI-img"
                >
                  <source
                    src="\assets\videos\Homepage-videos\AI-Powered.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="digital-land-hpb new-para">
                <h1 className="heading">AI Powered Metaverse</h1>
                <p className="para">
                  Discover Astrality, the future of AI-powered metaverses. Our
                  advanced AI underpins the Astrality experience, offering
                  personalized, seamless, and immersive digital journeys.
                  Unleash the potential of AI-enhanced metaverse interactions,
                  commerce, and security with Astrality. Your future begins
                  here.
                </p>
                <button className="btn-1 mt-3">Explore Now</button>
              </div>
            </div>
          </div>
        </div>
        {/* SocialFi */}
        <div className="market-place new">
          <div className="market-place-content">
            <div className="digital-land-hpb">
              <h1 className="heading">SocialFi</h1>
              <p className="para ">
                Engage, explore, and invest in Astrality's dynamic SocialFi
                platform. We're pushing boundaries in social finance, offering a
                vibrant community where interaction and investment converge.
                Harness the power of SocialFi and join the Astrality community.
                The future of digital social interaction and finance is here
              </p>
              <button className="btn-1 mt-3">Join Now</button>
            </div>
            <div className="digital-land-img">
              {/* <img
                src="\assets\images\HomePage-images\SocialFi.gif"
                alt="socialFi"
                className="img-fluid socialFi-new-img"
              /> */}
              <video
                autoPlay
                loop
                muted
                playsInline
                className="img-fluid socialFi-new-img"
              >
                <source
                  src="\assets\videos\Homepage-videos\SocialFi.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
        {/* Brands And Astrality */}
        <div className="brand-background digital-land-bg">
          <div className="digital-land ">
            <div className="digital-land-content  new-brand-content">
              <div className="digital-land-img new-brand">
                {/* <img
                  src="\assets\images\HomePage-images\Brands And Astrality.gif"
                  alt="Brands And Astrality"
                  className="img-fluid new-brand-img"
                /> */}
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="img-fluid new-brand-img"
                >
                  <source
                    src="\assets\videos\Homepage-videos\Brand And Astrality.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="digital-land-hpb">
                <h1 className="heading mt-5">Brands and Astrality</h1>
                <p className="para ">
                  Experience branding like never before with Astrality. We
                  empower brands by intertwining virtual and augmented reality,
                  crafting unique customer engagements in the metaverse. Take
                  your brand engagement to new dimensions with Astrality.
                  Explore our platform and redefine the boundaries of your
                  brand.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Advertisement */}
        <div className="market-place new-advertisement">
          <div className="market-place-content">
            <div className="digital-land-hpb">
              <h1 className="heading">Advertisement</h1>
              <p className="para ">
                In Astrality, revolutionize your brand's visibility. Rent
                digital land to showcase immersive VR-enabled ads, creating
                engaging and interactive experiences. Dive deeper into
                connections with consumers by launching virtual events or
                exclusive product lines. Leverage live analytics to optimize
                your strategies and innovate in real-time. In Astrality,
                advertising blends creativity, interactivity, and innovation.
              </p>
              <button className="btn-1 mt-3">Advertise now</button>
            </div>
            <div className="digital-land-img">
              {/* <video
                // src="\assets\images\HomePage-images\Advertisement.gif"
                src="\assets\videos\Homepage-videos\Advertisement.mp4"
                alt="socialFi"
                className="img-fluid new-advs-img"
              ></video> */}
              <video
                autoPlay
                loop
                muted
                playsInline
                className="img-fluid new-advs-img"
              >
                <source
                  src="\assets\videos\Homepage-videos\Advertisement.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>

        {/* User Reward */}
        <div className="market-place new-reward">
          <div className="market-place-content user-reward-new">
            <div className="digital-land-img ">
              {/* <img
                src="\assets\images\HomePage-images\UserReward.gif"
                alt="socialFi"
                className="img-fluid user-reward-img"
              /> */}
              <video
                autoPlay
                loop
                muted
                playsInline
                className="img-fluid user-reward-img"
              >
                <source
                  src="\assets\videos\Homepage-videos\UserReward.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="digital-land-hpb">
              <h1 className="heading">User Rewards</h1>
              <p className="para">
                Immerse yourself in Astrality, where loyalty is celebrated with
                rewarding experiences. Regular users are graced with daily
                rewards and thrilling lucky draws, earning exclusive in-game
                benefits and real-world perks. Each interaction opens up a
                gateway to potential rewards, making Astrality's journey
                thrilling and fruitful. Step into a realm where the virtual and
                the real collide, offering a rewarding metaverse experience like
                never before!
              </p>
              <div className="reward-button">
                <button className="btn-1 mt-3 ">Join Now</button>
                <button className="btn-explore mt-3 mx-5">Explore</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;
